import Reveal from "@/components/feature/Reveal";

export default function Statement() {
  return (
    <section className="relative py-24 md:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Moody_elegant_restaurant_interior_at_dusk_warm_candlelight_and_soft_golden_bokeh_dark_wood_tables_set_with_crystal_glassware_and_linen_napkins_intimate_upscale_dining_atmosphere_deep_shadows_with_warm_amber_highlights_cinematic_hospitality_photography_luxurious_and_inviting&width=1920&height=1080&seq=rjb4-statement-01&orientation=landscape"
          alt="Intimate upscale restaurant dining atmosphere"
          title="RJB4 Restaurant Group hospitality"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-foreground-950/80"></div>
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-4 md:px-6 text-center">
        <Reveal>
          <span className="inline-block w-12 h-12 rounded-full border border-accent-400/60 flex items-center justify-center">
            <i className="ri-double-quotes-l text-accent-300 text-xl"></i>
          </span>
          <h2 className="mt-8 font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight tracking-tight">
            Great Hospitality Starts With the Details.
          </h2>
          <p className="mt-6 text-background-100/80 text-base md:text-lg font-light leading-relaxed max-w-2xl mx-auto">
            At RJB4 Restaurant Group, we believe that memorable hospitality is created through
            a combination of people, process, atmosphere, and attention to detail.
          </p>
        </Reveal>
      </div>
    </section>
  );
}